export enum InfoBoardPostLayoutType {
  NoBackground = 'no_background',
  WithBackground = 'with_background',
}
